webpackJsonp([1],{

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import 'material-design-lite'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  computed: {
    // ...mapState({
    //
    // }),
    // ...mapGetters(['doubleup']),
    // halfCount () {
    //   return this.count / 2;
    // },
  },
  methods: {
    hideMenu: function hideMenu() {
      document.getElementsByClassName('mdl-layout__drawer')[0].classList.remove('is-visible');
      document.getElementsByClassName('mdl-layout__obfuscator')[0].classList.remove('is-visible');
    },
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().signOut().then(function () {
        _this.$router.push('login');
      });
    }
  },
  created: function created() {
    // console.log('created ')
    // console.log(this.$store.state.userData.user)
    this.$nextTick(function () {
      window.componentHandler.upgradeDom();
      window.componentHandler.upgradeAllRegistered();
    });
  }
});

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19e3ccba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(162);
function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19e3ccba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 157:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-layout mdl-layout mdl-js-layout mdl-layout--fixed-drawer mdl-layout--fixed-header"},[_c('header',{staticClass:"demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"},[_c('div',{staticClass:"mdl-layout__header-row"},[_c('span',{staticClass:"mdl-layout-title"},[(_vm.$store.state.companyData)?_c('span',[_vm._v(_vm._s(_vm.$store.state.companyData.company.name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mdl-layout-spacer"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right",attrs:{"for":"hdrbtn"}},[_c('li',{staticClass:"mdl-menu__item"},[_vm._v("About")]),_vm._v(" "),_c('li',{staticClass:"mdl-menu__item"},[_vm._v("Contact")]),_vm._v(" "),_c('li',{staticClass:"mdl-menu__item"},[_vm._v("Legal information")]),_vm._v(" "),_c('li',{staticClass:"mdl-menu__item",on:{"click":_vm.logout}},[_vm._v("Log Out")])])])]),_vm._v(" "),_c('div',{staticClass:"demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50"},[_vm._m(2),_vm._v(" "),_c('nav',{staticClass:"demo-navigation mdl-navigation mdl-color--blue-grey-800"},[_c('router-link',{staticClass:"mdl-navigation__link",attrs:{"to":"/home"},nativeOn:{"click":function($event){return _vm.hideMenu($event)}}},[_c('i',{staticClass:"mdl-color-text--blue-grey-400 material-icons",attrs:{"role":"presentation"}},[_vm._v("home")]),_vm._v("\n        Home\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"mdl-navigation__link",attrs:{"to":"/bills"},nativeOn:{"click":function($event){return _vm.hideMenu($event)}}},[_c('i',{staticClass:"mdl-color-text--blue-grey-400 material-icons",attrs:{"role":"presentation"}},[_vm._v("inbox")]),_vm._v("\n        All bills\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"mdl-navigation__link",attrs:{"to":"/add"},nativeOn:{"click":function($event){return _vm.hideMenu($event)}}},[_c('i',{staticClass:"mdl-color-text--blue-grey-400 material-icons",attrs:{"role":"presentation"}},[_vm._v("shopping_cart")]),_vm._v("\n        Add Bill\n      ")])],1)]),_vm._v(" "),_c('main',{staticClass:"mdl-layout__content mdl-color--grey-100"},[_c('router-view')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-textfield mdl-js-textfield mdl-textfield--expandable"},[_c('label',{staticClass:"mdl-button mdl-js-button mdl-button--icon",attrs:{"for":"search"}},[_c('i',{staticClass:"material-icons"},[_vm._v("search")])]),_vm._v(" "),_c('div',{staticClass:"mdl-textfield__expandable-holder"},[_c('input',{staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"search"}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label",attrs:{"for":"search"}},[_vm._v("Enter your query...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon",attrs:{"id":"hdrbtn"}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"demo-drawer-header"},[_c('img',{staticClass:"demo-avatar",attrs:{"src":__webpack_require__(16)}}),_vm._v(" "),_c('div',{staticClass:"demo-avatar-dropdown"},[_c('span',{attrs:{"id":"current-email"}},[_vm._v("hello@example.com")]),_vm._v(" "),_c('div',{staticClass:"mdl-layout-spacer"}),_vm._v(" "),_c('button',{staticClass:"mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon",attrs:{"id":"accbtn"}},[_c('i',{staticClass:"material-icons",attrs:{"role":"presentation"}},[_vm._v("arrow_drop_down")]),_vm._v(" "),_c('span',{staticClass:"visuallyhidden"},[_vm._v("Accounts")])]),_vm._v(" "),_c('ul',{staticClass:"mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect",attrs:{"for":"accbtn"}},[_c('li',{staticClass:"mdl-menu__item"},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v("Add another account...")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeView__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Auth__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SignUp__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ViewBill__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewBill__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Landing__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_auth__ = __webpack_require__(4);



// import Login from '@/components/Login'







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/login'
  }, {
    path: '/',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Auth__["a" /* default */]
  }, {
    path: '/sign-up',
    name: 'SignUp',
    component: __WEBPACK_IMPORTED_MODULE_4__components_SignUp__["a" /* default */]
  }, {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Landing__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/bills',
    name: 'bills',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeView__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/add',
    name: 'new-bill',
    component: __WEBPACK_IMPORTED_MODULE_6__components_NewBill__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: ':company/:bill/:success?',
    name: 'view-bill',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ViewBill__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }]
});
router.beforeEach(function (to, from, next) {
  // console.log(firebase.auth().currentUser)
  var currentUser = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  // console.log(to)
  // console.log(from)
  // console.log(currentUser)
  // console.log(requiresAuth)
  // console.log('requiresAuth && !currentUser : ' + (requiresAuth && (!currentUser)))
  // console.log('!requiresAuth && currentUser : ' + ((!requiresAuth) && currentUser))
  if (requiresAuth && !currentUser) {
    next('login');
  } else if (!requiresAuth && currentUser) {
    next('home');
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeView_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7f7d99_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeView_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e7f7d99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7f7d99_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 166:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-grid mdl-grid mdl-grid--no-spacing center-items"},_vm._l((_vm.$store.state.billsData.bills),function(bill){return (_vm.$store.state.billsData)?_c('div',{staticClass:"mdl-cell mdl-cell--6-col mdl-card mdl-shadow--6dp"},[_c('header',{staticClass:"mdl-card__title mdl-card--border"},[_c('span',{staticClass:"mdl-card__title-text"},[_c('span',[_vm._v(_vm._s(("Vechile No: " + (bill.vehiclenumber || 'Not Available'))))])]),_vm._v(" "),_c('div',{staticClass:"mdl-layout-spacer"}),_vm._v(" "),_c('pre',[_vm._v(" "+_vm._s("Bill No: ")+_vm._s(_vm._f("formatSequenceNumber")(bill.sequenceNumber)))])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-card__supporting-text"},[_c('div',[_c('strong',[_vm._v("Email:")]),_vm._v(" "+_vm._s(bill.emailaddress || 'Not Available'))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Name: ")]),_vm._v(_vm._s(bill.firstname)+" "+_vm._s(bill.lastname))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Amount:")]),_vm._v(" "+_vm._s(bill.amount || 'Not Available'))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Date:")]),_vm._v(" "+_vm._s(_vm._f("formatDate")(bill.timestamp)))])]),_vm._v(" "),_c('div',{staticClass:"mdl-grid mdl-card__actions mdl-card--border"},[_c('button',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-color-text--blue-grey-900 mdl-card--border mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":function($event){_vm.setBillValue(bill.id)}}},[_vm._v("\n              View Bill\n            ")])])]):_vm._e()})),_vm._v(" "),_c('router-link',{staticClass:"add-picture-button mdl-button mdl-js-button mdl-button--fab mdl-button--colored mdl-shadow--16dp",attrs:{"id":"action-button","to":"/add"}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7604ca5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(171);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7604ca5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {MyApp} from '../main.js'
// require('material-design-lite')
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  firestore: function firestore() {
    // return {
    //   // user: dbinstance.collection('users').doc(firebase.auth().currentUser.uid),
    //   bills: db.collection('companies/' + this.info.user.company + '/bills').orderBy('timestamp')
    // }
  },
  created: function created() {
    this.$nextTick(function () {
      window.componentHandler.upgradeDom();
      window.componentHandler.upgradeAllRegistered();
    });
  },

  methods: {
    setBillValue: function setBillValue(id) {
      this.$store.state.newBillState = this.$store.state.billsData.bills[id];
      var company = this.$store.state.userData.user.company;
      this.$router.push({ name: 'view-bill', params: { bill: id, company: company } });
    }
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"firebaseui-auth-container"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7544fdcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__(176);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7544fdcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7544fdcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mdl-grid center-items"},[_c('div',{staticClass:"mdl-cell mdl-cell--4-col mdl-cell--6-col-phone mdl-card mdl-shadow--6dp"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-card__supporting-text"},[_c('form',[_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"email"}},[_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"mdl-textfield__input",attrs:{"type":"password","id":"userpass"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"userpass"}},[_vm._v("Password")])])])]),_vm._v(" "),_c('div',{staticClass:"mdl-card__actions mdl-card--border"},[_c('button',{staticClass:"mdl-color-text--blue-grey-900 mdl-cell mdl-cell--12-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_vm._v("\n              Login\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"mdl-grid center-items"},[_c('div',{staticClass:"mdl-cell mdl-cell--4-col mdl-cell--6-col-phone mdl-card mdl-shadow--6dp"},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-card__supporting-text"},[_c('span',[_vm._v("To log in "),_c('router-link',{staticClass:"mdl-color-text--blue-grey-700",attrs:{"to":"/login"}},[_vm._v("login")]),_vm._v(".")],1)]),_vm._v(" "),_c('button',{staticClass:"mdl-card__actions mdl-color-text--blue-grey-900 mdl-cell mdl-cell--12-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":function($event){$event.preventDefault();return _vm.signInWithGoogle($event)}}},[_vm._v("\n              Login with Google\n            ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-card__title mdl-color--blue-grey-900 mdl-color-text--blue-grey-50"},[_c('h2',{staticClass:"mdl-card__title-text"},[_vm._v("Create Account")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewBill_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0aebe52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewBill_vue__ = __webpack_require__(180);
function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0aebe52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewBill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0aebe52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewBill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DEIVA.224004e.png";

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebaseui__);
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth',
  mounted: function mounted() {
    var uiConfig = {
      signInSuccessUrl: '/home',
      signInOptions: [__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.GoogleAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.EmailAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.PhoneAuthProvider.PROVIDER_ID]
    };
    var ui = new __WEBPACK_IMPORTED_MODULE_1_firebaseui___default.a.auth.AuthUI(__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth());
    ui.start('#firebaseui-auth-container', uiConfig);
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"mdl-grid mdl-grid--no-spacing center-items"},[_c('div',{staticClass:"mdl-cell mdl-cell--8-col mdl-card mdl-shadow--16dp"},[_c('header',{staticClass:"mdl-grid mdl-cell mdl-cell--12-col mdl-card__title mdl-card--border"},[_c('h3',{staticClass:"mdl-cell mdl-cell--12-col mdl-card__title-text"},[_vm._v("\n              Your Bill: "+_vm._s(_vm._f("formatSequenceNumber")(_vm.sequenceNumber))+"\n          ")]),_vm._v(" "),_c('h5',{staticClass:"mdl-cell mdl-cell--12-col mdl-card__subtitle-text"},[_vm._v("Name: "+_vm._s(_vm._f("uppercase")((_vm.firstname + " " + _vm.lastname))))])]),_vm._v(" "),_c('div',{attrs:{"id":"print"}},[_c('div',{staticClass:"mdl-grid center-items mdl-cell mdl-cell--7-col mdl-card__supporting-text"},[_c('div',{staticClass:"tb-con mdl-cell mdl-cell--12-col"},[_c('table',{staticClass:"fullwidth mdl-data-table mdl-js-data-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"mdl-cell mdl-cell--12-col center-items title mdl-card__subtitle-text",attrs:{"colspan":"4","id":"title"}},[_c('img',{staticClass:"mdl-cell mdl-cell--10-col",attrs:{"src":_vm.image}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Bill Number:")]),_vm._v(" "),_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v(_vm._s(_vm._f("formatSequenceNumber")(_vm.sequenceNumber)))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Vehicle Number:")]),_vm._v(" "),_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v(_vm._s(_vm._f("uppercase")(_vm.vehiclenumber)))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Name:")]),_vm._v(" "),_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v(_vm._s(_vm._f("titlecase")((_vm.firstname + " " + _vm.lastname))))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Phone:")]),_vm._v(" "),_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v(_vm._s(_vm.phonenumber))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Date:")]),_vm._v(" "),_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.timestamp)))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Amount:")]),_vm._v(" "),_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v(_vm._s(_vm._f("currency")(_vm.amount)))])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"tb-con mdl-cell mdl-cell--12-col"},[_c('table',{staticClass:"fullwidth mdl-data-table mdl-js-data-table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(key){return _c('tr',{attrs:{"id":"last-line"}},[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v(_vm._s(_vm._f("titlecase")(key.name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(key.qty))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(key.unitPrice)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(key.unitPrice * key.qty)))])])}))])])])]),_vm._v(" "),_c('div',{staticClass:"mdl-grid mdl-card__actions mdl-card--border"},[_c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":_vm.print}},[_vm._v("Print Bill")]),_vm._v(" "),_c('router-link',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",attrs:{"to":{ name: 'home'}}},[_vm._v("Back")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric",attrs:{"colspan":"4"}},[_vm._v("It is a Computer generated invoice, Please refer the identifiers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',[_vm._v("Unit price")]),_vm._v(" "),_c('th',[_vm._v("Cost")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewBill_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c233e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewBill_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21c233e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewBill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c233e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewBill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 182:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItem_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e365d41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItem_vue__ = __webpack_require__(198);
function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e365d41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e365d41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mdl-grid mdl-grid--no-spacing"},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-card"},[_c('div',{staticClass:"mdl-card__title mdl-color--grey-100 mdl-color-text--grey-600"},[_c('div',{staticClass:"mdl-layout-spacer"}),_vm._v(" "),_c('h2',{staticClass:"mdl-card__title-text"},[_vm._v("Amount : "+_vm._s(_vm.amount))])]),_vm._v(" "),_c('div',{attrs:{"id":"ta-con"}},[_c('table',{staticClass:"mdl-cell mdl-cell--12-col mdl-data-table mdl-js-data-table"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',[_c('td',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("\n                  "+_vm._s(item.name)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(item.qty)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(item.unitPrice)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(item.unitPrice * item.qty)+"\n                ")]),_vm._v(" "),_c('td',[_c('div',[_c('button',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-color-text--blue-grey-900 mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"submit",undefined,$event.key,undefined)){ return null; }$event.preventDefault();_vm.remove(index)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                      delete_forever\n                      ")])])])])])}),_vm._v(" "),_c('tr')],2)])])])]),_vm._v(" "),_c('div',{staticClass:"mdl-grid mdl-grid--no-spacing"},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp"},[_vm._m(1),_vm._v(" "),_c('form',{staticClass:"mdl-grid center-items mdl-cell mdl-cell--12-col"},[_c('div',{staticClass:"mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-textfield mdl-js-textfield mdl-textfield--floating-label",attrs:{"id":"name"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"name","placeholder":"Service","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"name"}},[_vm._v("Name")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qty),expression:"qty"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"qty","placeholder":"Quantity","required":""},domProps:{"value":(_vm.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qty=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"qty"}},[_vm._v("Quantity")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col mdl-cell--12-col-phone  mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.unitPrice),expression:"unitPrice"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"unitPrice","placeholder":"Unit Price","required":""},domProps:{"value":(_vm.unitPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.unitPrice=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"unitPrice"}},[_vm._v("Unit Price")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"cost","placeholder":"Cost","disabled":"","required":""},domProps:{"value":_vm.cost()}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"cost"}},[_vm._v("Cost")])])]),_vm._v(" "),_c('div',{staticClass:"mdl-card__actions mdl-card--border"},[_c('button',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-color-text--blue-grey-900 mdl-cell mdl-cell--12-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"submit",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.addItem($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n              add_shopping_cart\n            ")]),_vm._v(" Add Item\n          ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"mdl-data-table__cell--non-numeric"},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticClass:"mdl-data-table__cell"},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"mdl-data-table__cell"},[_vm._v("Unit Price")]),_vm._v(" "),_c('th',{staticClass:"mdl-data-table__cell"},[_vm._v("Cost")]),_vm._v(" "),_c('th',{staticClass:"mdl-data-table__cell"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-card__title mdl-color--grey-100 mdl-color-text--grey-600"},[_c('h2',{staticClass:"mdl-card__title-text"},[_vm._v("Item information")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"mdl-grid mdl-grid--no-spacing center-items"},[_c('div',{staticClass:"mdl-cell mdl-cell--10-col mdl-card mdl-shadow--2dp"},[_vm._m(0),_vm._v(" "),_c('div',[_c('AddItem',{attrs:{"parentData":_vm.items},on:{"childToParent":_vm.onAddItemsClick}})],1)])]),_vm._v(" "),_c('div',{staticClass:"mdl-grid mdl-grid--no-spacing center-items"},[_c('div',{staticClass:"mdl-cell mdl-cell--10-col mdl-card mdl-shadow--2dp"},[_vm._m(1),_vm._v(" "),_c('form',{staticClass:"mdl-grid center-items",on:{"submit":_vm.saveContact}},[_c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstname),expression:"firstname"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"firstname","pattern":"[A-Z,a-z]+","required":_vm.firstnameRequired},domProps:{"value":(_vm.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstname=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"firstname"}},[_vm._v("First Name")])]),_vm._v(" "),_c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastname),expression:"lastname"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"lastname","pattern":"[A-Z,a-z]+","required":_vm.lastnameRequired},domProps:{"value":(_vm.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastname=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"lastname"}},[_vm._v("Last Name")])]),_vm._v(" "),_c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehiclenumber),expression:"vehiclenumber"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"vehiclenumber","pattern":"[A-Z,a-z,0-9]+","required":_vm.vehiclenumberRequired},domProps:{"value":(_vm.vehiclenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.vehiclenumber=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"vehiclenumber"}},[_vm._v("Vehicle Number")])]),_vm._v(" "),_c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phonenumber),expression:"phonenumber"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"phonenumber","pattern":"[A-Z,a-z]+","required":_vm.phonenumberRequired},domProps:{"value":(_vm.phonenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phonenumber=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"phonenumber"}},[_vm._v("Phone Number")])]),_vm._v(" "),_c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailaddress),expression:"emailaddress"}],staticClass:"mdl-textfield__input",attrs:{"type":"text","id":"emailaddress"},domProps:{"value":(_vm.emailaddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailaddress=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mdl-textfield__label mdl-color-text--blue-grey-500",attrs:{"for":"emailaddress"}},[_vm._v("Email Address")])])]),_vm._v(" "),_c('div',{staticClass:"mdl-grid mdl-card__actions mdl-card--border"},[_c('button',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-color-text--blue-grey-900 mdl-card--border mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",on:{"click":_vm.saveContact}},[_vm._v("Save")]),_vm._v(" "),_c('router-link',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"mdl-color-text--blue-grey-900 mdl-card--border mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",attrs:{"to":{ name: 'home'}}},[_vm._v("Discard")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mdl-card__title mdl-card--border"},[_c('h3',{staticClass:"mdl-card__title-text mdl-card--border"},[_vm._v("\n              Create New Bill\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-items mdl-color--grey-100 mdl-color-text--grey-600 mdl-card__title"},[_c('h2',{staticClass:"mdl-card__title-text"},[_vm._v("Customer Details")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_firestore__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signUp',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    signUp: function signUp() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this.saveToFirestore();
        _this.$router.replace('home');
      }, function (err) {
        alert('Oops. ' + err.message);
      });
    },
    saveToFirestore: function saveToFirestore() {
      // console.log(firebase.auth().currentUser)
      var currentUserInfo = {
        displayName: __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().currentUser.displayName,
        email: __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().currentUser.email,
        emailVerified: __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().currentUser.emailVerified,
        phoneNumber: __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().currentUser.phoneNumber,
        photoURL: __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().currentUser.photoURL,
        providerId: __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().currentUser.providerData[0].providerId
      };
      __WEBPACK_IMPORTED_MODULE_0__main_js__["default"].collection('users').doc(__WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().currentUser.uid).set(currentUserInfo, { merge: true }).then(function () {
        console.log('Document successfully written!');
      }).catch(function (error) {
        console.error('Error writing document: ', error);
      });
    }
  },
  created: function created() {
    this.$nextTick(function () {
      window.componentHandler.upgradeDom();
      window.componentHandler.upgradeAllRegistered();
    });
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393a56cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-393a56cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393a56cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 201:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-grid mdl-grid mdl-grid--no-spacing center-items"},[_c('div',{staticClass:"mdl-cell mdl-cell--6-col mdl-card mdl-shadow--6dp"},[_c('header',{staticClass:"mdl-card__title mdl-card--border"},[(_vm.$store.state.userData)?_c('span',{staticClass:"mdl-card__title-text"},[_vm._v("\n            "+_vm._s(("Welcome " + (_vm.$store.state.userData.user.displayName)))+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col mdl-card__supporting-text"},[_vm._v("\n            You shall view your bill in 'All bills' menu\n      ")])]),_vm._v(" "),_c('router-link',{staticClass:"add-picture-button mdl-button mdl-js-button mdl-button--fab mdl-button--colored mdl-shadow--16dp",attrs:{"id":"action-button","to":"/add"}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 30,
	"./af.js": 30,
	"./ar": 31,
	"./ar-dz": 32,
	"./ar-dz.js": 32,
	"./ar-kw": 33,
	"./ar-kw.js": 33,
	"./ar-ly": 34,
	"./ar-ly.js": 34,
	"./ar-ma": 35,
	"./ar-ma.js": 35,
	"./ar-sa": 36,
	"./ar-sa.js": 36,
	"./ar-tn": 37,
	"./ar-tn.js": 37,
	"./ar.js": 31,
	"./az": 38,
	"./az.js": 38,
	"./be": 39,
	"./be.js": 39,
	"./bg": 40,
	"./bg.js": 40,
	"./bm": 41,
	"./bm.js": 41,
	"./bn": 42,
	"./bn.js": 42,
	"./bo": 43,
	"./bo.js": 43,
	"./br": 44,
	"./br.js": 44,
	"./bs": 45,
	"./bs.js": 45,
	"./ca": 46,
	"./ca.js": 46,
	"./cs": 47,
	"./cs.js": 47,
	"./cv": 48,
	"./cv.js": 48,
	"./cy": 49,
	"./cy.js": 49,
	"./da": 50,
	"./da.js": 50,
	"./de": 51,
	"./de-at": 52,
	"./de-at.js": 52,
	"./de-ch": 53,
	"./de-ch.js": 53,
	"./de.js": 51,
	"./dv": 54,
	"./dv.js": 54,
	"./el": 55,
	"./el.js": 55,
	"./en-au": 56,
	"./en-au.js": 56,
	"./en-ca": 57,
	"./en-ca.js": 57,
	"./en-gb": 58,
	"./en-gb.js": 58,
	"./en-ie": 59,
	"./en-ie.js": 59,
	"./en-il": 60,
	"./en-il.js": 60,
	"./en-nz": 61,
	"./en-nz.js": 61,
	"./eo": 62,
	"./eo.js": 62,
	"./es": 63,
	"./es-do": 64,
	"./es-do.js": 64,
	"./es-us": 65,
	"./es-us.js": 65,
	"./es.js": 63,
	"./et": 66,
	"./et.js": 66,
	"./eu": 67,
	"./eu.js": 67,
	"./fa": 68,
	"./fa.js": 68,
	"./fi": 69,
	"./fi.js": 69,
	"./fo": 70,
	"./fo.js": 70,
	"./fr": 71,
	"./fr-ca": 72,
	"./fr-ca.js": 72,
	"./fr-ch": 73,
	"./fr-ch.js": 73,
	"./fr.js": 71,
	"./fy": 74,
	"./fy.js": 74,
	"./gd": 75,
	"./gd.js": 75,
	"./gl": 76,
	"./gl.js": 76,
	"./gom-latn": 77,
	"./gom-latn.js": 77,
	"./gu": 78,
	"./gu.js": 78,
	"./he": 79,
	"./he.js": 79,
	"./hi": 80,
	"./hi.js": 80,
	"./hr": 81,
	"./hr.js": 81,
	"./hu": 82,
	"./hu.js": 82,
	"./hy-am": 83,
	"./hy-am.js": 83,
	"./id": 84,
	"./id.js": 84,
	"./is": 85,
	"./is.js": 85,
	"./it": 86,
	"./it.js": 86,
	"./ja": 87,
	"./ja.js": 87,
	"./jv": 88,
	"./jv.js": 88,
	"./ka": 89,
	"./ka.js": 89,
	"./kk": 90,
	"./kk.js": 90,
	"./km": 91,
	"./km.js": 91,
	"./kn": 92,
	"./kn.js": 92,
	"./ko": 93,
	"./ko.js": 93,
	"./ky": 94,
	"./ky.js": 94,
	"./lb": 95,
	"./lb.js": 95,
	"./lo": 96,
	"./lo.js": 96,
	"./lt": 97,
	"./lt.js": 97,
	"./lv": 98,
	"./lv.js": 98,
	"./me": 99,
	"./me.js": 99,
	"./mi": 100,
	"./mi.js": 100,
	"./mk": 101,
	"./mk.js": 101,
	"./ml": 102,
	"./ml.js": 102,
	"./mn": 103,
	"./mn.js": 103,
	"./mr": 104,
	"./mr.js": 104,
	"./ms": 105,
	"./ms-my": 106,
	"./ms-my.js": 106,
	"./ms.js": 105,
	"./mt": 107,
	"./mt.js": 107,
	"./my": 108,
	"./my.js": 108,
	"./nb": 109,
	"./nb.js": 109,
	"./ne": 110,
	"./ne.js": 110,
	"./nl": 111,
	"./nl-be": 112,
	"./nl-be.js": 112,
	"./nl.js": 111,
	"./nn": 113,
	"./nn.js": 113,
	"./pa-in": 114,
	"./pa-in.js": 114,
	"./pl": 115,
	"./pl.js": 115,
	"./pt": 116,
	"./pt-br": 117,
	"./pt-br.js": 117,
	"./pt.js": 116,
	"./ro": 118,
	"./ro.js": 118,
	"./ru": 119,
	"./ru.js": 119,
	"./sd": 120,
	"./sd.js": 120,
	"./se": 121,
	"./se.js": 121,
	"./si": 122,
	"./si.js": 122,
	"./sk": 123,
	"./sk.js": 123,
	"./sl": 124,
	"./sl.js": 124,
	"./sq": 125,
	"./sq.js": 125,
	"./sr": 126,
	"./sr-cyrl": 127,
	"./sr-cyrl.js": 127,
	"./sr.js": 126,
	"./ss": 128,
	"./ss.js": 128,
	"./sv": 129,
	"./sv.js": 129,
	"./sw": 130,
	"./sw.js": 130,
	"./ta": 131,
	"./ta.js": 131,
	"./te": 132,
	"./te.js": 132,
	"./tet": 133,
	"./tet.js": 133,
	"./tg": 134,
	"./tg.js": 134,
	"./th": 135,
	"./th.js": 135,
	"./tl-ph": 136,
	"./tl-ph.js": 136,
	"./tlh": 137,
	"./tlh.js": 137,
	"./tr": 138,
	"./tr.js": 138,
	"./tzl": 139,
	"./tzl.js": 139,
	"./tzm": 140,
	"./tzm-latn": 141,
	"./tzm-latn.js": 141,
	"./tzm.js": 140,
	"./ug-cn": 142,
	"./ug-cn.js": 142,
	"./uk": 143,
	"./uk.js": 143,
	"./ur": 144,
	"./ur.js": 144,
	"./uz": 145,
	"./uz-latn": 146,
	"./uz-latn.js": 146,
	"./uz.js": 145,
	"./vi": 147,
	"./vi.js": 147,
	"./x-pseudo": 148,
	"./x-pseudo.js": 148,
	"./yo": 149,
	"./yo.js": 149,
	"./zh-cn": 150,
	"./zh-cn.js": 150,
	"./zh-hk": 151,
	"./zh-hk.js": 151,
	"./zh-tw": 152,
	"./zh-tw.js": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function addStyles(win, styles) {
  styles.forEach(function (style) {
    var link = win.document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', style);
    // link.setAttribute('media', 'print')
    win.document.getElementsByTagName('head')[0].appendChild(link);
  });
}

var VueHtmlToPaper = {
  install: function install(Vue, options) {
    Vue.mixin({
      methods: {
        $htmlToPaper: function $htmlToPaper(el) {
          var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : options;
          var name = opts.name,
              specs = opts.specs,
              replace = opts.replace,
              styles = opts.styles;

          specs = specs.length ? specs.join(',') : '';

          var element = document.getElementById(el);

          if (!element) {
            alert('Element to print #' + el + ' not found!');
            return;
          }

          var url = '';
          var win = window.open(url, name, specs, replace);

          win.document.write('\n            <html>\n              <head>\n                <title>' + document.title + '</title>\n              </head>\n              <body>\n                ' + element.innerHTML + '\n              </body>\n              <style>\n                @media print {\n                  @page {\n                    size: 5.5in 11.in; /* landscape */\n                    /* you can also specify margins here: */\n                    margin-left: 10mm;\n                    margin-right: 10mm; /* for compatibility with both A4 and Letter */\n\n                  }\n                  .fullwidth { width: 99%; }\n                  .mdl-grid{\n                    margin: 8px;\n                    -webkit-print-color-adjust:exact;\n                  }\n                  #title{\n                    text-align: left;\n                    height: 200px;\n                    width:200px;\n                  }\n                  .center-items {\n                    justify-content: center;\n                  }\n                  .mdl-data-table{\n                    white-space:nowrap\n                  }\n                  .mdl-data-table td{\n                    padding: 8px 8px;\n                  }\n                  .mdl-data-table tbody tr{\n                    height: 30px;\n                  }\n                  .mdl-data-table tbody td{\n                    height: 30px;\n                  }\n                  .mdl-data-table tbody tr:last-of-type{\n                    border-bottom:4px double rgba(0,0,0,.12);\n                  }\n                  .mdl-data-table thead{\n                    display: contents\n                  }\n                  .mdl-data-table td:last-of-type, .mdl-data-table th:last-of-type{\n                    border-right: 2px solid rgba(0,0,0,.12)\n                  }\n                  img{\n                      display: block;\n                      margin: auto;\n                  }\n                }\n                .fullwidth { width: 99%; }\n                .mdl-grid{\n                  margin: 8px;\n                  -webkit-print-color-adjust:exact;\n                }\n                #title{\n                  text-align: left;\n                  height: 200px;\n                  width:200px;\n                }\n                .center-items {\n                  justify-content: center;\n                }\n                .mdl-data-table{\n                  white-space:nowrap\n                }\n                .mdl-data-table td{\n                  padding: 8px 8px;\n                }\n                .mdl-data-table tbody tr{\n                  height: 30px;\n                }\n                .mdl-data-table tbody td{\n                  height: 30px;\n                }\n                .mdl-data-table tbody tr:last-of-type{\n                  border-bottom:4px double rgba(0,0,0,.12);\n                }\n                .mdl-data-table td:last-of-type, .mdl-data-table th:last-of-type{\n                  border-right: 2px solid rgba(0,0,0,.12)\n                }\n              </style>\n            </html>\n          ');

          addStyles(win, styles);

          setTimeout(function () {
            // win.document.close()
            win.focus();
            win.print();
            // win.close()
          }, 1000);
          return true;
        }
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VueHtmlToPaper);

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_DEIVA_png__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_DEIVA_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_DEIVA_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import 'firebase/firestore'

// require('material-design-lite')
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'view-bill',
  data: function data() {
    return {
      firstname: '',
      lastname: '',
      emailaddress: '',
      phonenumber: '',
      amount: '',
      items: [],
      slug: '',
      timestamp: '',
      vehiclenumber: '',
      sequenceNumber: 0,
      success: this.$route.params.success,
      style: {
        backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_1__assets_DEIVA_png___default.a + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'inherit',
        backgroundPosition: 'center'
      },
      image: __WEBPACK_IMPORTED_MODULE_1__assets_DEIVA_png___default.a
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    console.log(to.params.company);
    console.log(to.params.bill);
    var doc = __WEBPACK_IMPORTED_MODULE_0__main_js__["MyApp"].vue.$store.state.newBillState; // MyApp.vue.$store.state.billsData.bills[to.params.bill]
    console.log(__WEBPACK_IMPORTED_MODULE_0__main_js__["MyApp"].vue.$store.state.newBillState);
    next(function (vm) {
      vm.firstname = doc.firstname;
      vm.lastname = doc.lastname;
      vm.emailaddress = doc.emailaddress;
      vm.phonenumber = doc.phonenumber;
      vm.amount = doc.amount;
      vm.slug = doc.slug;
      vm.timestamp = doc.timestamp;
      vm.items = doc.items;
      vm.vehiclenumber = doc.vehiclenumber;
      vm.sequenceNumber = doc.sequenceNumber;
    });
    // MyApp.vue.$store.dispatch('billData/openDBChannel', {companyId: to.params.company, billId: to.params.bill}).then(
    //   () => {
    //     next(vm => { // whereFilters: ['slug', '==', '{slug}']
    //       let doc = MyApp.vue.$store.state.billData.bill
    //       console.log(doc)
    //       vm.firstname = doc.firstname
    //       vm.lastname = doc.lastname
    //       vm.emailaddress = doc.emailaddress
    //       vm.phonenumber = doc.phonenumber
    //       vm.amount = doc.amount
    //       vm.slug = doc.slug
    //       vm.timestamp = doc.timestamp
    //       vm.items = doc.items
    //       vm.vehiclenumber = doc.vehiclenumber
    //       vm.sequenceNumber = doc.sequenceNumber
    //     })
    //   }
    // ).catch(console.error)

    // db.collection('companies/' + to.params.company + '/bills').where('slug', '==', to.params.bill).get().then((querySnapshot) => {
    //   querySnapshot.forEach((doc) => {
    //     next(vm => {
    //       vm.firstname = doc.data().firstname
    //       vm.lastname = doc.data().lastname
    //       vm.emailaddress = doc.data().emailaddress
    //       vm.phonenumber = doc.data().phonenumber
    //       vm.amount = doc.data().amount
    //       vm.slug = doc.data().slug
    //       vm.timestamp = doc.data().timestamp
    //       vm.items = doc.data().items
    //       vm.vehiclenumber = doc.data().vehiclenumber
    //       vm.sequenceNumber = doc.data().sequenceNumber
    //     })
    //   })
    // })
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      // db.collection('companies/' + this.$root.$data.user.company + '/bills').where('slug', '==', this.$route.params.bill).get().then((querySnapshot) => {
      //   querySnapshot.forEach((doc) => {
      //     console.log(doc.id, ' => ', doc.data())
      //     this.firstname = doc.data().firstname
      //     this.lastname = doc.data().lastname
      //     this.emailaddress = doc.data().emailaddress
      //     this.phonenumber = doc.data().phonenumber
      //     this.amount = doc.data().amount
      //     this.items = doc.data().items
      //     this.slug = doc.data().slug
      //     this.timestamp = doc.data().timestamp
      //     this.vehiclenumber = doc.data().vehiclenumber
      //     this.sequenceNumber = doc.data().sequenceNumber
      //     this.success = this.$route.params.success
      //   })
      // })
      console.log(this.$route.params.company);
      console.log(this.$route.params.bill);
      // MyApp.vue.$store.dispatch('billData/openDBChannel', {companyId: this.$route.params.company, billId: this.$route.params.bill}).then(
      //   () => {
      //     // whereFilters: ['slug', '==', '{slug}']
      //     let doc = MyApp.vue.$store.state.billData.bill
      //     console.log(doc)
      //     this.firstname = doc.firstname
      //     this.lastname = doc.lastname
      //     this.emailaddress = doc.emailaddress
      //     this.phonenumber = doc.phonenumber
      //     this.amount = doc.amount
      //     this.slug = doc.slug
      //     this.timestamp = doc.timestamp
      //     this.items = doc.items
      //     this.vehiclenumber = doc.vehiclenumber
      //     this.sequenceNumber = doc.sequenceNumber
      //   })
      //   .catch(console.error)
      var doc = __WEBPACK_IMPORTED_MODULE_0__main_js__["MyApp"].vue.$store.state.newBillState;
      console.log(doc);
      this.firstname = doc.firstname;
      this.lastname = doc.lastname;
      this.emailaddress = doc.emailaddress;
      this.phonenumber = doc.phonenumber;
      this.amount = doc.amount;
      this.slug = doc.slug;
      this.timestamp = doc.timestamp;
      this.items = doc.items;
      this.vehiclenumber = doc.vehiclenumber;
      this.sequenceNumber = doc.sequenceNumber;
    },
    print: function print() {
      this.$htmlToPaper('print');
    }
  },
  created: function created() {
    this.$nextTick(function () {
      window.componentHandler.upgradeDom();
      window.componentHandler.upgradeAllRegistered();
    });
  }
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AddItem__ = __webpack_require__(196);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import firebase from 'firebase/app'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-bill',
  components: {
    AddItem: __WEBPACK_IMPORTED_MODULE_3__components_AddItem__["a" /* default */]
  },
  props: {
    parentData: Object
  },
  data: function data() {
    return {
      firstname: null,
      lastname: null,
      emailaddress: null,
      phonenumber: null,
      amount: null,
      items: null,
      vehiclenumber: null,
      firstnameRequired: false,
      lastnameRequired: false,
      phonenumberRequired: false,
      vehiclenumberRequired: false
    };
  },

  methods: {
    saveContact: function saveContact(event) {
      if (!this.validate()) {
        return false;
      }
      event.preventDefault();
      var slug = this.generateUUID();
      this.total();
      // db.collection('companies/' + this.user.company + '/bills').add({
      this.incrementAndUpdateBill(slug);
    },
    incrementAndUpdateBill: function incrementAndUpdateBill(slug) {
      var _this = this;

      var user = this.$store.state.userData.user;
      var billDocRef = void 0;
      var newBillState = void 0;
      __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].runTransaction(function (t) {
        var companyRef = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].collection('companies').doc(user.company);
        return t.get(companyRef).then(function (doc) {
          var currentBillNumber = doc.data().currentBillNumber + 1;
          t.update(companyRef, { currentBillNumber: currentBillNumber });
          billDocRef = __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].collection('companies/' + user.company + '/bills').doc();
          newBillState = {
            firstname: _this.firstname,
            lastname: _this.lastname,
            emailaddress: _this.emailaddress,
            phonenumber: _this.phonenumber,
            amount: _this.amount,
            items: _this.items,
            slug: slug,
            timestamp: new Date().getTime(),
            type: __WEBPACK_IMPORTED_MODULE_2__main_js__["MyApp"].vue.env,
            vehiclenumber: _this.vehiclenumber,
            sequenceNumber: currentBillNumber
          };
          t.set(billDocRef, newBillState);
        });
      }).then(function (result) {
        console.log('incrementAndUpdateBill Transaction success!');
        // console.log(`${user.company}/${billDocRef.id}/success/${billDocRef.sequenceNumber}`)
        _this.$store.state.newBillState = newBillState;
        _this.$router.push({ name: 'view-bill', params: { bill: billDocRef.id, company: user.company, success: 'success' } });
      }).catch(function (err) {
        console.log('incrementAndUpdateBill Transaction failure:', err);
      });
    },

    // getUserAndUpdate (slug) {
    // db.collection('users').doc(firebase.auth().currentUser.uid).get()
    //   .then(doc => {
    //     if (!doc.exists) {
    //       console.log('No such user with id: ' + firebase.auth().currentUser.uid)
    //     } else {
    //       console.log('Document user data:', doc.data())
    //       this.incrementAndUpdateBill(slug, doc.data())
    //     }
    //   })
    //   .catch(err => {
    //     console.log('Error getting document', err)
    //   })

    // }
    // ,
    // getCompany () {
    //   db.collection('companies').doc(this.getUser().company).get()
    //     .then(doc => {
    //       if (!doc.exists) {
    //         console.log('No such company')
    //       } else {
    //         console.log('Document company data:', doc.data())
    //         return doc.data()
    //       }
    //     })
    //     .catch(err => {
    //       console.log('Error getting document', err)
    //     })
    // },
    generateUUID: function generateUUID() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return uuid;
    },
    onAddItemsClick: function onAddItemsClick(items) {
      this.items = items;
    },
    total: function total() {
      this.amount = this.items.reduce(function (accumulator, item) {
        return accumulator + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(item.qty) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(item.unitPrice);
      }, 0);
    },
    validate: function validate() {
      var status = true;

      if (this.firstname === null) {
        this.firstnameRequired = 'required';
        status = false;
      }
      if (this.lastname === null) {
        this.lastnameRequired = 'required';
        status = false;
      }
      if (this.phonenumber === null) {
        this.phonenumberRequired = 'required';
        status = false;
      }
      if (this.vehiclenumber === null) {
        this.vehiclenumberRequired = 'required';
        status = false;
      }
      console.log(status);
      return status;
    }
  },
  created: function created() {
    this.$nextTick(function () {
      window.componentHandler.upgradeDom();
      window.componentHandler.upgradeAllRegistered();
    });
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// require('material-design-lite')
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-item',
  data: function data() {
    return {
      amount: 0,
      name: null,
      qty: null,
      unitPrice: null,
      items: []
    };
  },

  methods: {
    cost: function cost() {
      return this.qty * this.unitPrice;
    },
    addItem: function addItem() {
      this.items.push({ name: this.name, qty: this.qty, unitPrice: this.unitPrice });
      this.total();
      this.name = null;
      this.qty = null;
      this.unitPrice = null;
      this.complete();
    },
    remove: function remove(index) {
      this.items.splice(index, 1);
      this.total();
    },
    total: function total() {
      this.amount = this.items.reduce(function (accumulator, item) {
        return accumulator + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(item.qty) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(item.unitPrice);
      }, 0);
    },
    complete: function complete(event) {
      this.$emit('childToParent', this.items);
    }
  },
  created: function created() {
    this.$nextTick(function () {
      window.componentHandler.upgradeDom();
      window.componentHandler.upgradeAllRegistered();
    });
  }
});

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  }
});

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MyApp", function() { return MyApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_firestore__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_user_jpg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_user_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_user_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_design_lite__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_design_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_design_lite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_easy_firestore__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_printer__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_currency_filter__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_currency_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_currency_filter__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_material_design_lite___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_currency_filter___default.a, {
  symbol: 'Rs',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
});

var options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=no', 'scrollbars=no'],
  styles: ['https://fonts.googleapis.com/icon?family=Material+Icons', 'https://code.getmdl.io/1.2.1/material.blue-red.min.css']
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__components_printer__["a" /* default */], options);

var config = {
  apiKey: 'AIzaSyBqbdlyQZIPF2bGL0WNp-7qNi0kCF_H5rM',
  authDomain: 'testdata-32ade.firebaseapp.com',
  databaseURL: '"https://testdata-32ade.firebaseio.com',
  projectId: 'testdata-32ade',
  storageBucket: 'testdata-32ade.appspot.com',
  messagingSenderId: '816312989969'
};

var firebaseApp = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.initializeApp(config);

var settings = { timestampsInSnapshots: true };
var dbinstance = firebaseApp.firestore();
dbinstance.settings(settings);
dbinstance.enablePersistence().catch(function (err) {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code === 'unimplemented') {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
});

/* eslint-disable no-new */

var userDataModule = {
  firestorePath: 'users/{userId}',
  firestoreRefType: 'doc', // 'collection' or 'doc'
  moduleName: 'userData',
  statePropName: 'user',
  // you can also add state/getters/mutations/actions
  // for other config like fillables see 'Extra features'
  serverChange: {
    defaultValues: {
      displayName: 'Alice'
    }
  }
};
var companyDataModule = {
  firestorePath: 'companies/{companyId}',
  firestoreRefType: 'doc',
  moduleName: 'companyData',
  statePropName: 'company',
  serverChange: {
    defaultValues: {
      name: 'Alice'
    }
  }
};
var billsDataModule = {
  firestorePath: 'companies/{companyId}/bills',
  firestoreRefType: 'collection',
  moduleName: 'billsData',
  statePropName: 'bills',
  sync: {
    orderBy: ['timestamp', 'desc'],
    whereFilters: ['type', '===', 'PROD']
  },
  serverChange: {
    addedHook: function addedHook(updateStore, doc, id, store, source, change) {
      // console.log(doc)
      updateStore(doc);
    },
    modifiedHook: function modifiedHook(updateStore, doc, id, store, source, change) {
      // console.log(doc)
      updateStore(doc);
    },
    removedHook: function removedHook(updateStore, doc, id, store, source, change) {
      updateStore(doc);
    }
  }
};
var billDataModule = {
  firestorePath: 'companies/{companyId}/bills/{billId}',
  firestoreRefType: 'doc',
  moduleName: 'billData',
  statePropName: 'bill'
  // sync: { // .where('slug', '==', to.params.bill)
  //   whereFilters: ['slug', '===', '{slug}']
  // }
};
var easyFirestore = Object(__WEBPACK_IMPORTED_MODULE_10_vuex_easy_firestore__["a" /* default */])([userDataModule, companyDataModule, billsDataModule, billDataModule], { logging: true });
var store = new __WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* default */].Store({
  state: {
    userData: { user: { displayName: 'Raavanan' } },
    companyData: { company: { name: 'inception' } }
  },
  mutations: {
    increment: function increment(state) {
      state.count++;
    }
  },
  plugins: [easyFirestore]
});

var MyApp = {};
MyApp.store = store;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('mdl', {
  bind: function bind(el) {
    window.componentHandler.upgradeElement(el);
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date(value)).format('DD/MM/YYYY hh:mm');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatSequenceNumber', function (value) {
  if (value) {
    return ('00000' + value).slice(-5).toString();
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('uppercase', function (value) {
  if (value) {
    return value.toUpperCase();
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('titlecase', function (value) {
  if (value) {
    var splitStr = value.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
});

var saveToFirestore = function saveToFirestore() {
  var currentUserInfo = {};
  if (__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.displayName) currentUserInfo.displayName = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.displayName;
  if (__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.email) currentUserInfo.email = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.email;
  if (__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.emailVerified) currentUserInfo.emailVerified = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.emailVerified;
  if (__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.phoneNumber) currentUserInfo.phoneNumber = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.phoneNumber;
  if (__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.photoURL) currentUserInfo.photoURL = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.photoURL;
  if (__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.providerData[0].providerId) currentUserInfo.providerId = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.providerData[0].providerId;
  console.log(currentUserInfo);
  __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.app().firestore().collection('users').doc(__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.uid).set(currentUserInfo, { merge: true }).then(function () {
    console.log('saveToFirestore Document successfully written!');
  }).catch(function (error) {
    console.error('saveToFirestore Error writing document: ', error);
  });
};

var initData = function initData() {
  store.dispatch('userData/openDBChannel').then(function () {
    store.dispatch('companyData/openDBChannel', { companyId: store.state.userData.user.company });
    store.dispatch('billsData/openDBChannel', { companyId: store.state.userData.user.company });
  }).catch(console.error);
};
__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
  if (user) {
    initData();
  } else {
    store.dispatch('companyData/closeDBChannel', { clearModule: true });
    console.log('Auth rejected');
  }
  appInit(user);
});

var appInit = function appInit(user) {
  if (!MyApp.vue) {
    MyApp.vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      /* eslint-disable no-new */
      el: '#app',
      template: '<App/>',
      components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
      router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
      store: store,
      data: {
        db: dbinstance,
        env: 'PROD'
      },
      created: function created() {
        this.$nextTick(function () {
          window.componentHandler.upgradeDom();
          window.componentHandler.upgradeAllRegistered();
        });
      },

      methods: {}
    });
  }
  if (user) {
    saveToFirestore();
    if (user.photoURL) document.getElementsByClassName('demo-avatar')[0].src = user.photoURL;
    if (user.email) document.getElementById('current-email').innerHTML = user.email;
  } else {
    document.getElementsByClassName('demo-avatar')[0].src = __WEBPACK_IMPORTED_MODULE_6__assets_user_jpg___default.a;
    document.getElementById('current-email').innerHTML = 'hello@example.com';
  }
};

/* harmony default export */ __webpack_exports__["default"] = (dbinstance);


/***/ })

},[5]);


// WEBPACK FOOTER //
// static/js/app.9398202f9c86c05acda2.js